import { useEffect, useState } from "preact/hooks";

// Tracks the most recently-copied key and clears it after `timeoutMs` so
// callers can render a transient check icon. The key (any string the caller
// chooses — e.g. an r2Key or "primary") lets a single hook drive per-row
// indicators in a list. Errors propagate to the caller; this hook only
// manages the timer.
export function useClipboardCopy(timeoutMs = 1500) {
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(null), timeoutMs);
    return () => clearTimeout(t);
  }, [copied, timeoutMs]);

  async function copy(key: string, text: string): Promise<void> {
    await navigator.clipboard.writeText(text);
    setCopied(key);
  }

  return { copied, copy };
}
